<template>
  <div class="details-container">
    <b-row>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity1 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 1:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit1 }}
      </b-col>
    </b-row>

    <b-row v-if="row.item.appointment2">
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity2 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 2:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit2 }}
      </b-col>
    </b-row>

    <b-row v-if="row.item.appointment3">
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity3 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 3:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit3 }}
      </b-col>
    </b-row>

    <b-row v-if="row.item.appointment4">
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment4 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString4 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality4 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity4 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 4:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit4 }}
      </b-col>
    </b-row>

    <b-row v-if="row.item.appointment5">
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment5 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString5 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality5 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity5 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 5:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit5 }}
      </b-col>
    </b-row>

    <b-row v-if="row.item.appointment6">
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment6 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString6 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality6 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity6 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 6:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit6 }}
      </b-col>
    </b-row>

    <b-row v-if="row.item.appointment7">
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointment7 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment' | i18n }} String 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentString7 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'appointment_quality' | i18n }} 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.appointmentQuality7 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity' | i18n }} 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantity7 }}
      </b-col>
      <b-col
        sm="2"
        class="details-column text-sm-right"
      >
        <span>{{ 'available_quantity_sales_unit' | i18n }} 7:</span>
      </b-col>
      <b-col
        sm="1"
        class="details-column"
      >
        {{ row.item.availableQuantitySalesUnit7 }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {BCol, BRow} from 'bootstrap-vue';

export default {
  name: 'AppointmentGridDetailsRow',
  components: {'b-row': BRow, 'b-col': BCol},
  props: {
    row: {
      type: Object,
      default: () => {
      }
    }
  }
};
</script>

<style scoped>

</style>
